import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import * as log from '@/model/util/log/Logger'


export default /*#__PURE__*/_defineComponent({
  __name: 'ButtonLoading',
  props: {
  // アイコンか
  icon: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props

log.trace(`ButtonLoading.vue setup start.`)

// プロパティ定義


log.trace(`ButtonLoading.vue setup end.`)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(["spinner-border spinner-border-sm", { 'mxa-icon': props.icon }]),
    role: "status",
    "aria-hidden": "true",
    "data-test": "button_loading"
  }, null, 2))
}
}

})